import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryError: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBatteryError"><Path fillRule="evenodd" clipRule="evenodd" d="M1 5V19H20V16H23V8H20V5H1ZM20 9.5V14.5H21.5V9.5H20ZM7.43934 10L8.5 8.93934L10.5 10.9393L12.5 8.93934L13.5607 10L11.5607 12L13.5607 14L12.5 15.0607L10.5 13.0607L8.5 15.0607L7.43934 14L9.43934 12L7.43934 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryError;
